import { ReportFrequency } from '@core/referential/frequency.enum'
import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetAllReportPathParameterSchema = z.object({
  siteId: numberOrStringToNumberSchema,
})

export const GetAllReportResponseSchema = z.array(
  z.object({
    id: z.string(),
    frequency: z.nativeEnum(ReportFrequency),
    name: z.string().optional(),
    startDate: z.union([z.date(), z.string().trim()]),
    fileId: z.string().uuid(),
  }),
)

export type GetAllReportPathParameter = z.infer<typeof GetAllReportPathParameterSchema>
export type GetAllReportResponse = z.infer<typeof GetAllReportResponseSchema>
